export default function LoadingState() {
  return (
    <div aria-busy="true" aria-label="Analyzing…">
      <p style={{ margin: '0 0 12px', fontSize: '14px', color: 'var(--asneris-muted)' }}>
        Analyzing your website… this usually takes 5–15 seconds.
      </p>
      <span className="asneris-skeleton" style={{ height: '100px', display: 'block', marginBottom: '16px' }} />
      <span className="asneris-skeleton" style={{ height: '48px', display: 'block', marginBottom: '8px' }} />
      <span className="asneris-skeleton" style={{ height: '48px', display: 'block', marginBottom: '8px' }} />
      <span className="asneris-skeleton" style={{ height: '48px', display: 'block' }} />
    </div>
  );
}
